import styled from 'styled-components';
export default styled.span.withConfig({
  displayName: "styledBefore",
  componentId: "p1bbkq-0"
})(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"]);